const extractBaseUrl = (inputString) => {
	let url = inputString.trim();
	const protocolRegex = /^(https?|ftp):\/\//;
	const match = url.match(protocolRegex);
	const protocol = match ? match[0] : '';
	if (protocol) {
		url = url?.replace(protocolRegex, '');
	}
	const domainAndPath = url.split('/')[0];
	return protocol + domainAndPath + '/';
};

export default extractBaseUrl;
